// extracted by mini-css-extract-plugin
export default {"content":"CardPreview_content__gHcoU","header":"CardPreview_header__P3mUR","title":"CardPreview_title__DX+S-"};